import React from 'react';
import QuoteForm from './QuoteForm';
import './Hero.css';

export default function Hero() {
  return (
    <section className="hero">
      <div className="hero-in">
        {/* Left column */}
        <div className="hero-content">
          <div className="hero-badge">
            <span className="badge-dot" />
            My Home Warranty — coverage in all 50 states
          </div>

          <h1>
            Protect Your Home{' '}
            <em>Before the Next Breakdown</em>
          </h1>

          <p className="hero-sub">
            Get a free instant quote in under 3 minutes. Compare plans covering
            HVAC, plumbing, electrical, appliances &amp; more — no inspection required.
          </p>

          <div className="stats">
            <div className="stat">
              <div className="stat-num">1M+</div>
              <div className="stat-lbl">Homes covered</div>
            </div>
            <div className="stat">
              <div className="stat-num">3 min</div>
              <div className="stat-lbl">Free quote in</div>
            </div>
            <div className="stat">
              <div className="stat-num">24/7</div>
              <div className="stat-lbl">Claims support</div>
            </div>
            <div className="stat">
              <div className="stat-num">50</div>
              <div className="stat-lbl">States served</div>
            </div>
          </div>

          <div className="trust">
            <span className="trust-lbl">As featured on</span>
            {['BBB A+', 'NerdWallet', 'CNBC Select', 'Forbes Home'].map((b) => (
              <span key={b} className="trust-tag">{b}</span>
            ))}
          </div>
        </div>

        {/* Right column – quote form */}
        <QuoteForm />
      </div>
    </section>
  );
}
